module.exports = __webpack_public_path__ + "img/3.bba4f1a9.jpg";